import React from 'react';
import cx from 'classnames';
import s from './style';

import nothingFound from 'assets/images/nothingfound.png';
import { useTranslation } from 'react-i18next';

function NoPage({ className }) {
  const classes = cx(s.root, className);
  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className={cx(s.Rectangle)}>
        <img className={cx(s.Image)} src={nothingFound} alt="nothing found" />
        <div className={cx(s.Info)}>
          <span className={cx(s.InfoTitle)}>
            {t('components.clientCollection.noPageTitle')}
          </span>
          <span className={cx(s.InfoSubTitle)}>
            {t('components.clientCollection.noPageSubTitle')}
          </span>
        </div>
      </div>
    </div>
  );
}

export default NoPage;



// WEBPACK FOOTER //
// ./src/components/ClientCollection/NoPage/index.js